module.exports = __webpack_public_path__ + "static/media/kr.7d6e1425.webp";